<div class="dynamic-content-wrapper">
  @if (loading) {
    <div>
      Loading content...
    </div>
  }

  @if (error) {
    <div>
      {{ error }}
    </div>
  }

  @if (content && !loading && !error) {
    <div class="dynamic-content" [innerHTML]="content" (click)="handleClick($event)"></div>
  }
</div>
